import savedItemIcon from '@/assets/saved_item_icon.png';
import selectSavedItemIcon from '@/assets/selected_saved_item_icon.png';
import { useAccount } from '@/hooks/useAccount';
import { setAllAccountItemsVisibility } from '@/lib/account-data';
import { db } from "@/lib/db";
import { Button, Group, Text } from "@mantine/core";
import { notifications } from '@mantine/notifications';
import { useLiveQuery } from "dexie-react-hooks";
import MenuTab from "./MenuTab";

interface SavedItemsMenuItemProps {
    children?: React.ReactNode;
}

const SavedItemsMenuItem: React.FC<SavedItemsMenuItemProps> = ({ children }) => {
    const { userId } = useAccount();
    const savedItems = useLiveQuery(() => db.savedItems.where('ownerId').equals(userId).toArray(), [userId]);
    const anyItemsVisible = savedItems?.some((item) => item.visible) ?? false;

    const setAllVisible = async (visible: boolean) => {
        try { await setAllAccountItemsVisibility(userId, visible); }
        catch { notifications.show({ color: 'red', message: 'Visibility could not be updated. Please try again.' }); }
    }

    return (
        <MenuTab
            item='items'
            label='Saved Items'
            icon={savedItemIcon}
            selectedIcon={selectSavedItemIcon}
            title={
                <Group align='center' justify='space-between'>
                    <Text size='md'>Saved Items</Text>
                    <Button variant='transparent' size='sm' color='pq-red' onClick={() => void setAllVisible(!anyItemsVisible)}>
                        {anyItemsVisible ? 'All Off' : 'All On'}
                    </Button>
                </Group>
            }>
            {children}
        </MenuTab>
    );
}

export default SavedItemsMenuItem;
